import { render, staticRenderFns } from "./FloorInfo.vue?vue&type=template&id=4fc7071b&scoped=true&"
import script from "./FloorInfo.vue?vue&type=script&lang=js&"
export * from "./FloorInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc7071b",
  null
  
)

export default component.exports